/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAnalytics } from "../context/AnalyticsContext";

export const useImpressionObserver = (ref, propertyId) => {
  const { logEvent } = useAnalytics();

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          logEvent.impression(propertyId);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, propertyId, logEvent]);
};

export const useViewLogger = (propertyId, auto = true) => {
  const { logEvent } = useAnalytics();

  const trackView = () => {
    if (!propertyId) return;
    logEvent.view(propertyId);
    console.log("view tracked")
  };

  useEffect(() => {
    if (auto) trackView();
  }, [propertyId]);

  return { trackView };
};



// export const useTrackClicks = (propertyId) => {
//   const { logEvent } = useAnalytics();

//   return {
//     trackViewClick: () => logEvent.viewClick(propertyId),
//     trackContactClick: () => logEvent.contact_click(propertyId),
//     trackPhoneReveal: () => logEvent.phone_reveal(propertyId),
//     trackWhatsapp: () => logEvent.whatsapp_click(propertyId),
//     trackShare: () => logEvent.share(propertyId),
//     trackLead: () => logEvent.lead_generated(propertyId),
//   };
// };

export const useTrackClicks = (propertyId) => {
  const { logEvent } = useAnalytics();

  return {
    trackViewClick: () => {
      console.log("📊 view_click →", propertyId);
      logEvent.viewClick(propertyId);
    },

    trackContactClick: () => {
      console.log("📊 contact_click →", propertyId);
      logEvent.contactClick(propertyId);
    },

    trackPhoneReveal: () => {
      console.log("📊 phone_reveal →", propertyId);
      logEvent.phoneReveal(propertyId);
    },

    trackWhatsapp: () => {
      console.log("📊 whatsapp_click →", propertyId);
      logEvent.whatsappClick(propertyId);
    },

    trackShare: () => {
      console.log("📊 share →", propertyId);
      logEvent.share(propertyId);
    },

    trackLead: () => {
      console.log("📊 lead_generated →", propertyId);
      logEvent.leadGenerated(propertyId);
    },
  };
};
